import React from "react";
import "./InitialNoticeTemplate.scss";

type InitialNoticeTemplateProps = {
  image: string;
  title?: string;
  children: any;
};

const InitialNoticeTemplate = (props: InitialNoticeTemplateProps) => {
  const { image, title, children } = props;

  return (
    <div className="initial-notice-template">
      <div className="initial-notice-template-wrapper">
        <div className="initial-notice-template-image">
          <img src={image} className="initial-notice-template-image-src" alt="" />
        </div>
        {Boolean(title) && <div className="initial-notice-template-title">{title}</div>}
      </div>
      <div className="initial-notice-template-body">{children}</div>
    </div>
  );
};

export default InitialNoticeTemplate;
